module.exports = __webpack_public_path__ + "img/Incoming red.af448b58.png";